export * from './partial/fieldKeys';

export const FORM_TYPE = {
    TRAVEL_GUARANTEE: 'TravelGuarantee',
    REFUND: 'Refund',
    ORDER_TIMETABLE: 'OrderTimetable'
};

export const TRAVEL_GUARANTEE_TYPE = {
    TAXI: 'Taxi',
    MILEAGE: 'Mileage',
    OTHER: 'Goodwill'
};

export const REFUND_TYPE = {
    TICKETING_APP: 'AppId',
    TRAVEL_CARD: 'Number'
};
